import React from 'react';
import {Link} from 'react-router-dom';
import APPCONFIG from 'constants/Config';
import Framework from "@beardeddevops/react.framework";
import NavLeftList from './NavLeftList';
import NavRightList from './NavRightList';
import PropTypes from "prop-types";

const FrameworkHeader = Framework.Components.withRootState(Framework.Elements.Header)

export default class Header extends React.Component {
	static propTypes = {
		name: PropTypes.string,
		kioskMode: PropTypes.any,
		regions: PropTypes.array.isRequired,
		history: PropTypes.object.isRequired,
		reloadShell: PropTypes.func.isRequired,
		isToggle: PropTypes.bool,
		region: PropTypes.array
	};

	constructor(props) {
		super(props);
		this.state = {
			isToggle : true
		};
	}

	componentDidMount() {
	}

	render() {

		const navLeft = <NavLeftList roles ={this.props.roles} name={this.props.name} history={this.props.history} reloadShell={this.props.reloadShell} thermometer_data={this.props.thermometer_data} account={this.props.account} active={this.props.active}/>

		const navRight = <NavRightList account={this.props.account} name={this.props.name} history={this.props.history} reloadShell={this.props.reloadShell} roles ={this.props.roles} notifications={this.props.notifications}/>

		return (
			<FrameworkHeader
				pin={false}
				shouldShowBrand={true}
				brandLink={<Link to="/" className="brand">{APPCONFIG.brand}</Link>}
				navLeft={navLeft}
				navRight={navRight}
			/>


			/*<section className="app-header no-print">
				<div className='app-header-inner bg-color-dark'>
					<div className="">

					</div>

					<div className="brand d-none">
						<h2><Link to="/">{APPCONFIG.brand}</Link></h2>
					</div>
					<div className="top-nav-left">


					</div>
					<div className="top-nav-right">

					</div>
				</div>
			</section>*/
		);
	}
}
